<template>
  <div class="countryLeaguesBox" v-if="country.id">
    <div class="flex flex-align-center title">
      <img
        class="country-flag"
        :src="common.countryDataImgGet(country.id)"
        @error="common.imgError($event, 'country')"
      />
      <div>{{ country.name }}</div>
    </div>
    <ul class="league-list">
      <li
        v-for="(item, index) in country.league || []"
        :key="item.id"
        :class="[
          item.id == league.id ? 'active' : '',
          index >= amount && !more ? 'hidden' : '',
        ]"
        @click="leagueChange(index)"
      >
        <span :title="item.fullName || item.shortName">{{
          item.shortName || item.fullName
        }}</span>
      </li>
    </ul>
    <div
      class="more flex flex-align-center flex-pack-center"
      v-if="country.league.length > amount && !more ? true : false"
      @click="more = true"
    >
      <span>{{ langConfig.leagues[langConfig.curLang]['MORE'] }}</span>
      <i class="league-title-icon icon-font icon-arr"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "countryLeagues",
  props: ["country", "league"],
  data() {
    return {
      amount: 10, // 默认显示多少条
      more: false, // 隐藏更多
    };
  },
  methods: {
    leagueChange(index) {
      this.$emit("leagueChange", this.country, this.country.league[index]);
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="less" scoped>
.countryLeaguesBox {
  padding: 16px 0;
  width: 168px;

  .title {
    font-family: @font_family_SF_Pro_Display;
    font-weight: bold;
    padding-bottom: 16px;
    position: relative;
    margin: 0 8px;

    img {
      width: 18px;
      margin-right: 8px;
      height: 12px;
    }
  }

  .title::after {
    display: block;
    content: "";
    background: #d9d9d9;
    width: 100%;
    height: 1px;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .league-list {
    padding-top: 8px;

    li {
      margin: 0 8px;
      padding: 8px 0;
      cursor: pointer;
      color: @color_434343;
      font-size: 14px;
      font-family: @font_family_SF_Pro_Display;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-radius: 4px;

      &:hover,
      &.active {
        color: @color_FF6915;
      }

      &.hidden {
        display: none;
      }
    }
  }

  .more {
    color: @color_434343;
    font-family: @font_family_SF_Pro_Display;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid @color_BFBFBF;
    width: 152px;
    height: 24px;
    margin: 8px auto 0;
    cursor: pointer;

    i {
      color: @color_434343;
      font-size: 14px;
      margin-left: 4px;
      transform: rotate(-180deg);
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/leagues/components/countryLeagues.vue